<template>
  <div class="wg-row com-anm22-app-inner-wrapper">
    <!-- MODALE lista movimenti -->
    <wg-modal 
        :width="windowWidth > 900 ? '50%' : '90%'" 
        v-if="showLogsDialog" 
        @closeModal="showLogsDialog = false">
      <div class="com-anm22-app-text-xl" slot="header">
        {{ $anm22.strLang(lang, 'Logs', 'Movimenti') }}
      </div>
      <logs
          slot="body"
          :license="license"
          :timezone="timezone"
      ></logs>
    </wg-modal>
    <!-- MODALE gestione scorte -->
    <wg-modal 
        :width="'90%'" 
        v-if="showLoadingDialog" 
        @closeModal="showLoadingDialog = false">
      <div class="com-anm22-app-text-xl" slot="header">
        {{ $anm22.strLang(lang, 'Load/Unload', 'Carico/Scarico') }}
      </div>
      <loading-list 
          slot="body"
          :license="license"
          :timezone="timezone"
          @close="showLoadingDialog = false"
      ></loading-list>
    </wg-modal>
    <!-- MODALE importazione prodotti -->
    <wg-modal 
        :width="windowWidth > 900 ? '50%' : '90%'" 
        v-if="showImportDialog" 
        @closeModal="showImportDialog = false">
      <div class="com-anm22-app-text-xl" slot="header">
        {{ $anm22.strLang(lang, 'Import products', 'Importazione prodotti') }}
      </div>
      <import-csv slot="body"></import-csv>
    </wg-modal>
    <!-- MODALE esportazione prodotti -->
    <wg-modal 
        :width="'300px'" 
        v-if="showExportDialog" 
        @closeModal="showExportDialog = false">
      <div class="com-anm22-app-text-xl" slot="header">
        {{ $anm22.strLang(lang, 'Export', 'Esportazione') }}
      </div>
      <export-csv slot="body"></export-csv>
    </wg-modal>
    <!-- MODALE gestione prodotto -->
    <wg-modal 
        :width="windowWidth > 900 ? '900px' : '90%'" 
        v-if="showProductDialog" 
        :portal="true" 
        @closeModal="closeProduct">
      <div class="com-anm22-app-text-xl" slot="header">
        {{ this.selectedProduct && this.selectedProduct.idFoodProduct 
            ? $anm22.strLang(lang, 'Edit product', 'Modifica prodotto')
            : $anm22.strLang(lang, 'Add product', 'Nuovo prodotto')
        }}
      </div>
      <product-detail
          slot="body" 
          :productRef="selectedProduct"
      ></product-detail>
    </wg-modal>
    <!-- MODALE filtri -->
    <anm22-dialog-filter 
        v-if="showFilterDialog"
        :allFilters="productFilters" 
        :selected="selectedFilters"
        @applyFilters="filterProducts($event)"
        @closeFilter="showFilterDialog = false;">
    </anm22-dialog-filter>
    <!-- TITOLO PAGINA -->
    <div class="wg-row" style="justify-content:space-between;">
      <div class="com-anm22-page-title" style="font-size:24px;">
        {{ $anm22.strLang(lang, 'Products', 'Prodotti') }}
      </div>
      <div class="display-flex" style="flex-wrap:nowrap;align-items:center;">
        <button class="small" @click="showLogsDialog = true">
          <img :src="$anm22.icons.getWorldIcon('list')">
          <div v-if="windowWidth > 767">{{ $anm22.strLang(lang, 'Movements', 'Movimenti') }}</div>
        </button>
        <button class="small" style="margin-left:10px;" @click="showLoadingDialog = true">
          <img :src="$anm22.icons.getWorldIcon('importExport')">
          <div v-if="windowWidth > 767">{{ $anm22.strLang(lang, 'Load/Unload', 'Carico/Scarico') }}</div>
        </button>
        <button class="small" style="margin-left:10px;" @click="$router.push({name: 'categories'})">
          <img :src="$anm22.icons.getWorldIcon('open')">
          <div v-if="windowWidth > 767">{{ $anm22.strLang(lang, 'Categories', 'Categorie') }}</div>
        </button>
      </div>
    </div>
    <!-- PULSANTI -->
    <divclass="wg-row" style="flex-wrap:nowrap;align-items:center;">
      <button class="small" @click="newProduct">
        <img :src="$anm22.icons.getWorldIcon('add')">
        <div v-if="windowWidth > 767">{{ $anm22.strLang(lang, 'New', 'Nuovo') }}</div>
      </button>
      <button class="small" style="margin-left:10px;" @click="showImportDialog = true">
        <img :src="$anm22.icons.getWorldIcon('upload')">
        <div v-if="windowWidth > 767">{{ $anm22.strLang(lang, 'Import', 'Importa') }}</div>
      </button>
      <button class="small" style="margin-left:10px;" @click="showExportDialog = true">
        <img :src="$anm22.icons.getWorldIcon('download')">
        <div v-if="windowWidth > 767">{{ $anm22.strLang(lang, 'Export', 'Esporta') }}</div>
      </button>
      <button class="small" style="margin-left:10px;" @click="showFilterDialog = true">
        <img :src="$anm22.icons.getWorldIcon('filterList')">
        <div v-if="windowWidth > 767">{{ $anm22.strLang(lang, 'Filters', 'Filtri') }}</div>
      </button>
    </divclass="wg-row">
    <div class="vertical-height-div" style="height:20px;"></div>
    <!-- LISTA PRODOTTI -->
    <div class="wg-row" :style="{height:listHeight+'px'}">
      <w-g-list
          v-if="products.length > 0"
          :loading="loading"
          :pagination="true"
          :fieldInit="'category'"
          :keyField="'id'"
          :clickFn="p => openProduct(p)"
          :headerItems="listHeader"
          :itemsToDisplay="listRows"
      >
        <template v-slot:default="{ element, data }">
          <div class="wg-row item-row" style="padding:10px 0;">
            <div class="wg-col wg-xs-2" style="cursor:pointer;">
              <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
                <div class="com-anm22-app-text-l ellipsed" :title="element.code">
                  {{ element.code }}
                </div>
              </div>
            </div>
            <div class="wg-col wg-xs-4" style="cursor:pointer;">
              <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
                <div class="com-anm22-app-text-l ellipsed" :title="element.langName">
                  {{ element.langName }}
                </div>
              </div>
            </div>
            <div class="wg-col wg-xs-3">
              <div class="com-anm22-app-text-l ellipsed" :title="data.category.langName">
                {{ data.category.langName }}
              </div>
            </div>
            <div class="wg-col wg-xs-1" >
              <img 
                class="com-anm22-app-img-fixed-height-m"
                :src="getStatusIcon(element.status)"
              >
            </div>
            <div class="wg-col wg-xs-2">
              <div class="com-anm22-app-text-l" >
                {{ element.stockType !== 1 ? element.quantity : $anm22.strLang(lang, 'Unlimited', 'Illimitato') }}
              </div>
            </div>
          </div>
        </template>
      </w-g-list>
      <div v-else class="com-anm22-app-text-xxl">
        {{ $anm22.strLang(lang, 'No products', 'Nessun prodotto') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import WGList from '../../../../../world/spa/components/WGList.vue';
import ProductDetail from '../../components/inventory/ProductDetail.vue';
import ImportCSV from '../../components/inventory/ImportCSV.vue';
import ExportCSV from '../../components/inventory/ExportCSV.vue';
import LoadingList from "../../components/inventory/LoadingList.vue";
import Logs from "../../components/inventory/Logs.vue";
import Anm22DialogFilter from '../../../../../world/spa/components/Anm22DialogFilter.vue';

export default {
  data() {
    return {
      loading: false,
      /* Gestione prodotto */
      selectedProduct: null,
      showProductDialog: false,
      showImportDialog: false,
      showExportDialog: false,
      showLoadingDialog: false,
      showLogsDialog: false,
      /* Filters */
      showFilterDialog: false,
      selectedFilters: []
    }
  },
  components: {
    WGList,
    ProductDetail,
    ImportCsv: ImportCSV,
    ExportCsv: ExportCSV,
    LoadingList,
    Logs,
    Anm22DialogFilter
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline
    }),
    listHeight() {
      return this.windowHeight - 220;
    },
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
    work() {
      return this.$store.getters['works/get'](this.license.work);
    },
    timezone() {
      return this.work.timezone;
    },
    categories() {
      return this.$store.getters['foodCategories/getByLicense'](this.license.id).filter(c => !c.deleted);
    },
    products() {
      return this.$store.getters['foodProducts/getByLicense'](this.license.id)
        .filter(p => {
          return !p.deleted && this.selectedFilters
            .reduce(
              (result, selectedFilter) => {
                const filter = this.productFilters.find(f => f.id === selectedFilter.id);
                return result && filter.apply(p, selectedFilter.value);
              }, 
              true
            );
        });
    },
    listHeader() {
      return [
        {
          field: 'code',
          label: this.$anm22.strLang(this.lang, 'Code', 'Codice'),
          class: 'wg-xs-2',
          disabled: false,
        },
        {
          field: 'langName',
          label: this.$anm22.strLang(this.lang, 'Name', 'Nome'),
          class: 'wg-xs-4',
          disabled: false,
        },
        {
          field: 'category',
          label: this.$anm22.strLang(this.lang, 'Category', 'Categoria'),
          class: 'wg-xs-3',
          disabled: false,
        },
        {
          field: 'status',
          label: this.$anm22.strLang(this.lang, 'Status', 'Stato'),
          class: 'wg-xs-1',
          disabled: false,
        },
        {
          field: 'quantity',
          label: this.$anm22.strLang(this.lang, 'Amount', 'Quantità'),
          class: 'wg-xs-2',
          disabled: false,
        }
      ]
    },
    listRows() {
      if(this.products) {
        return this.products.map(p => {
          const category = this.$store.getters['foodCategories/get'](p.category);
          return {
            ...p,
            'list-metadata': {
              type: 'item',
              category: category
            }
          }
        });
      } else {
        return [];
      }
    },
    productFilters() {
      return [        
        /* Categorie */
        {
          id: 'category',
          label: this.$anm22.strLang(this.lang, 'Category', 'Categoria'),
          type: 'select',
          values: [
            ...this.categories.map(c => {
              return {
                label: c.langName,
                value: c.id
              }
            })
          ],
          apply: (product, value) => {
            return product.category == value;
          }
        },
        {
          /* Categorie visibili/non visibili */
          id: 'visibility',
          label: this.$anm22.strLang(this.lang, 'Category visibility', 'Visibilità categoria'),
          type: 'select',
          values: [
            {
              label: this.$anm22.strLang(this.lang, 'Only visible', 'Solo categorie visibili'),
              value: 1
            },
            {
              label: this.$anm22.strLang(this.lang, 'Only hidden', 'Solo categorie nascoste'),
              value: 0
            }
          ],
          apply: (product, value) => {
            const category = this.$store.getters['foodCategories/get'](product.category);
            return category.visible == value;
          }
        }
      ]
    }
  },
  methods: {
    filterProducts(newFilters) {
      /* Save filters in cookie */
      this.$anm22.setCookie(
        'ps-p-filters', 
        JSON.stringify(newFilters.reduce((r,f) => {
          r.push([f.id, f.value]);
          return r;
        }, [])), 
        31536000
      );
      this.selectedFilters = newFilters;
      this.showFilterDialog = false;
    },
    newProduct() {
      const localId = this.$anm22.genLocalId();
      // Category preset
      let category = '';
      if(this.$anm22.getCookie('com-anm22-food-cat-preset') !== '') {
        category = this.$store.getters['foodCategories/get'](Number(this.$anm22.getCookie('com-anm22-food-cat-preset')));
      } else {
        category = this.categories[0];
      }
      this.openProduct({
        id: localId,
        dbKey: localId,
        license: this.license.id,
        code: '',
        category: category.id,
        pinToTop: '',
        manufacturer: '',
        pricingType: 1,
        uom: 1,
        price: '',
        vat: category.defaultVat,
        stockType: 1,
        quantity: '',
        quantityThreshold: '',
        status: 1,
        visibleByCustomer: '',
        image: '',
        iconName: '',
        colorString: '',
        idPrinter: 0,
        variations: [],
        deleted: false
      });
    },
    openProduct(p) {
      this.selectedProduct = p;
      this.showProductDialog = true;
    },
    closeProduct() {
      this.showProductDialog = false;
      this.selectedProduct = null;
    }, 
    getStatusIcon(status) {
      switch(status) {
        case 1:
          return this.$anm22.icons.getWorldIcon('done');
          break;
        case 2:
          return this.$anm22.icons.getWorldIcon('visibilityOff');
          break;
        case 3:
          return this.$anm22.icons.getWorldIcon('emptyCart')
      }
    },
    loadData() {
      return Promise.all(
        [
          this.$store.dispatch('foodCategories/load', this.$vlf('foodCategories')),
          this.$store.dispatch('foodProducts/load', this.$vlf('foodProducts')),
          this.$store.dispatch('foodPrinters/load', this.$vlf('foodPrinters')),
        ]
      )
      .then(() => {
        this.loading = false;
        this.$Progress.finish();
      });
    }
  },
  created() {
    document.title = this.$anm22.strLang(this.lang, 'Inventory', 'Inventario');
    this.$store.dispatch(
      "headbar/setHeadbarTitle",
      this.$anm22.strLang(this.lang, 'Inventory', 'Inventario')
    );
    this.loading = true;
    this.loadData();
    this.$http
      .get("inventory")
      .then(response => {
        Promise.all([
          this.$store.dispatch('foodCategories/update', {
            vlf: this.$vlf('foodCategories'),
            objs: response.data.categories,
            cleanFilters: []
          }),
          this.$store.dispatch('foodProducts/update', {
            vlf: this.$vlf('foodProducts'),
            objs: response.data.products,
            cleanFilters: []
          })
        ])
        .then(() => {

        })
      });
  },
  watch: {
    products(newVal, old) {
      if(this.selectedProduct && this.selectedProduct.id) {
        this.selectedProduct = newVal.find(p => p.id === this.selectedProduct.id);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item-row {
  height: 36px;
  padding: 10px;
  &:hover {
    background-color: #fff;
  }
  .ellipsed {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
